import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext, SET_ZONE } from '../context/AppContext';
import { useUrlState } from '../utils/urlState';
import { BrowserView, MobileView } from 'react-device-detect';
import StateMap from '../components/StateMap';
import CountryMap from '../components/region-maps/CountryMap';
import PacificMap from '../components/region-maps/regions/PacificMap';
import RockyMountainMap from '../components/region-maps/regions/RockyMountainMap';
import MidwestMap from '../components/region-maps/regions/MidwestMap';
import SouthwestMap from '../components/region-maps/regions/SouthwestMap';
import NortheastMap from '../components/region-maps/regions/NortheastMap';
import SoutheastMap from '../components/region-maps/regions/SoutheastMap';
import backButton from '../images/ui_buttons/back_button.png';
import ZoneSelectorMobile from './ZoneSelector.mobile';
import '../css/header.css';
import '../css/body.css';
import '../css/animations.css';

const ZoneSelector = () => {
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);
  const [currentAnimation, setCurrentAnimation] = useState('');
  const navigate = useNavigate();
  const { state, dispatch } = useAppContext();
  const { navigateWithParams } = useUrlState();

  // Navigate to the previous screen
  const handleBack = () => {
    console.log(state);
    navigate('/');
  };

  // Function for navigating to the next hierarchy down in the region maps
  const handleSelectRegion = (regionId) => {
    setCurrentAnimation('exit-to-left');
    setTimeout(() => {
      setSelectedRegion(regionId);
      setCurrentAnimation('enter-from-right');
    }, 500);
  };

  const handleBackToCountry = () => {
    setCurrentAnimation('exit-to-right');
    setTimeout(() => {
      setSelectedRegion(null);
      setCurrentAnimation('enter-from-left');
    }, 500);
  };

  // Logic for choosing selected state
  const handleSelectState = (stateId) => {
    console.log(`handleSelectState is working with this state: ${stateId}`);
    const singleZoneStates = {
      CT: 'CT_ZA',
      DE: 'DE_ZA',
      MD: 'MD_ZA',
      NJ: 'NJ_ZA',
      RI: 'RI_ZA',
    };
    if (singleZoneStates[stateId]) {
      const zoneId = singleZoneStates[stateId];
      handleSelectZone(zoneId);
      return;
    }
    setCurrentAnimation('exit-to-left');
    setTimeout(() => {
      setSelectedState(stateId);
      setCurrentAnimation('enter-from-right');
    }, 500);
  };

  const handleBackToRegion = () => {
    setCurrentAnimation('exit-to-right');
    setTimeout(() => {
      setSelectedState(null);
      setCurrentAnimation('enter-from-left');
    }, 500);
  };

  // Logic for choosing selected region
  const handleSelectZone = (zoneId) => {
    setSelectedZone(zoneId);
    dispatch({ type: SET_ZONE, payload: zoneId });
    navigateWithParams('/house-editor', { zone: zoneId });
  };

  const renderMap = () => {
    if (!selectedRegion) {
      return <CountryMap onRegionClick={handleSelectRegion} />;
    }

    switch (selectedRegion) {
      case 'pacific':
        return <PacificMap onStateClick={handleSelectState} />;
      case 'rocky-mountains':
        return <RockyMountainMap onStateClick={handleSelectState} />;
      case 'midwest':
        return <MidwestMap onStateClick={handleSelectState} />;
      case 'southwest':
        return <SouthwestMap onStateClick={handleSelectState} />;
      case 'northeast':
        return <NortheastMap onStateClick={handleSelectState} />;
      case 'southeast':
        return <SoutheastMap onStateClick={handleSelectState} />;
      default:
        return null;
    }
  };

  const renderStateOrZoneMap = () => {
    if (selectedState) {
      return (
        <StateMap
          stateId={selectedState}
          onZoneClick={handleSelectZone}
          selectedZone={selectedZone}
        />
      );
    }
    return renderMap();
  };

  return (
    <>
      <BrowserView>
        <div className='full-container'>
          <header>
            <button onClick={handleBack} className='back-button'>
              <img src={backButton} alt='Back' className='button-image' />
            </button>
            <h1>Choose your Region</h1>
            <div> </div>
          </header>
          <div className={`map-body-container ${currentAnimation}`}>
            {renderStateOrZoneMap()}
            {selectedRegion && !selectedState && (
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <h3>Choose a different region?</h3>
                <button onClick={handleBackToCountry}>Back</button>
              </div>
            )}
            {selectedRegion && selectedState && (
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <h3>Choose a different state?</h3>
                <button onClick={handleBackToRegion}>Back</button>
              </div>
            )}
          </div>
        </div>
      </BrowserView>
      <MobileView>
        <ZoneSelectorMobile
          selectedState={selectedState}
          selectedZone={selectedZone}
          selectedRegion={selectedRegion}
          setSelectedState={setSelectedState}
          setSelectedZone={setSelectedZone}
          setSelectedRegion={setSelectedRegion}
          handleSelectState={handleSelectState}
          handleSelectRegion={handleSelectRegion}
          handleBackToRegion={handleBackToRegion}
          handleBackToCountry={handleBackToCountry}
          handleSelectZone={handleSelectZone}
          currentAnimation={currentAnimation}
          setCurrentAnimation={setCurrentAnimation}
        />
      </MobileView>
    </>
  );
};

export default ZoneSelector;
